import { render, staticRenderFns } from "./RefItemAdd.vue?vue&type=template&id=3090d01a&"
import script from "./RefItemAdd.vue?vue&type=script&lang=ts&"
export * from "./RefItemAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports